import { render } from "./MyTopBarButtonSignOut.vue?vue&type=template&id=5a0713a0"
import script from "./MyTopBarButtonSignOut.vue?vue&type=script&lang=js"
export * from "./MyTopBarButtonSignOut.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__